import styled from "styled-components";

export const StyledMyInfoDialog = styled.div`
  width: 100%;
  .my-info-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    padding-bottom: 8px;
    .myinfo-chip {
      width: 100px;
      justify-content: flex-start;
      padding-left: 5px;
      flex-shrink: 0;
    }
    > p {
      word-break: break-all;
      font-size: 14px;
    }

    &:not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }
  }
`;
